<template>
    <section>
        <div>

            <h1 class="title">Why putting your life in <span class="filled">perspective</span> may be the best thing for you</h1>
            <br>
            <p>
                <strong>Time flies!</strong> This is probably one of the most popular proverbs we've been hearing since little kids. As unfortunate this is, it's a fate that we're all going to die eventually. The only choice we have is: <strong>what to do about it?</strong>
            </p>
            <p>
                We always tell ourselves that we should learn French, Spanish, or hit the gym. We also never do any of these things. Why do we keep pushing ourselves from the beings we want to be?
            </p>
            <p>
                Usually, we don’t feel the time passing. If we did, we'd see how fast it slips through our fingers into nothingness we’d be starting our steps into our journey now.
            </p>
            <Quote quote="There is never enough time to enjoy what you love." author="Joyce Rachelle" />
            <p>
                If you are old enough to be reading the odds are that you remember when you used to play with your friends in the kindergarten, or when you first fell in love... or even when your mother or father hugged you at the end of the school day. Isn’t weird how long ago everything happened? It sure feels like moments ago.
            </p>
            <Quote quote="time flies so fast. day by day left us. with or without smiles, the new days will comes." author="Nunki Artura" />
            <p>
                Putting things in perspective may be the push we need to start now what we've been postponing for so many days, months, or years. When we look at our time that already has passed we are reminded of the time we have left and how fast the chart is being filled.
            </p>
            <Quote quote="The bad news is time flies. The good news is you're the pilot." author="Michael Altshuler" />
            <!-- <p>
                To <strong>put things in perspective</strong>, if you live till the global life expectancy of <a target="_blank" href="https://www.who.int/gho/mortality_burden_disease/life_tables/situation_trends_text/en/#:~:text=Global%20life%20expectancy%20at%20birth,men%20all%20around%20the%20world.">72 years (74.2 years for females and 69.8 years for males)</a> you already lived <strong>43.5%</strong> of your life.
            </p> -->
        </div>
        <div>
            <h1 class="title">What should we do about the <span class="filled">time passing</span>?</h1>
            <br>
            <p>
                Unfortunately, there are no magical answers to that. One thing that we know, though, is that whatever you want for your life <strong>now is the time you should be doing it.</strong> <br> We have no idea what kind of surprises, either good or bad, the world has to us for tomorrow. Even if the interactive chart above showed that you most probably have (statistically speaking) <strong v-if="birthdate">{{weeksLeftToLive}} weeks, {{monthsLeftToLive}} months or {{yearsLeftToLive}} years more to live</strong><span v-else> a lot of time ahead of you</span>, there’s no way of knowing it for sure.
            </p>
            <Quote quote='We must not fall asleep in the present because the now moment is the only reality we truly have.' author="Kat Lahr, Anatomy Of Illumination" />
            <br>
            <Quote quote='Looking to the future for happiness is but a mirage—Life is happening now.' author="Anoir Ou-Chad" />
            <br>
            <p>
                There are many great things we can do to improve our lives. Learning more about the world and ourselves is for sure one of them. Thus, take a moment to read a book, learn something new whenever you can, and don’t stress out, life is too short. Here’s the list of the top {{ books.length }} Best-Selling Self Help books of all time you could read:
            </p>
            <ul class="book-list">
                <li v-for="book in books" v-bind:key="book.id"><Book :book="book" /></li>
            </ul>
            <!-- <ul>
                <li>Think and grow Rich - Napoleon Hill</li>
                <li>The Alchemist - Paulo Coelho</li>
                <li>You Can Heal Your Life - Louise Hay</li>
                <li>Rich Dad, Poor Dad - Robert T. Kiyosaki</li>
                <li>The 7 Habits of Highly Effective People - Stephen R. Covey</li>
                <li>Don’t Sweat the Small Stuff… And It’s All Small Stuff - Richard Carlson </li>
                <li>Who Moved My Cheese? - Spencer Johnson</li>
                <li>The Celestine Prophecy - James Redfield</li>
                <li>The Secret - Rhonda Byrne</li>
                <li>The Power of Positive Thinking - Norman Vincent Peale</li>
            </ul> -->
            <Quote quote='The only true wisdom is in knowing you know nothing.' author="Socrates" /><br>
            <p>
                Just a side note, the average reading speed is 200 to 250 words per minute and the average book has 90.000 words; <strong>if you had taken just 1h per day to read since the start of this year, you would have read {{ amountOfBooks }} books just this year.</strong>
            </p>
            <Quote quote='Empirically speaking, there is no such thing as history, destiny and even future for that matter, what there really is, is the “now”. And this very “now” – this very moment is the only thing which you have in your hands – in fact, it is the only time that actually exists – the “now”. So, be aware of that “now”and you will literally begin to see all moments like a true seer, without all the mystical nonsense.' author="Abhijit Naskar, Time to Save Medicine" />
        </div>
    </section>
</template>

<script>
import Quote from './Quote';
import Book from './Book';
import { DateTime } from "luxon";
export default {
    name: 'Articles',
    props: ['birthdate', 'lifeExpectancyInYears'],
    components: {
        Quote,
        Book
    },
    data() {
        return {
            books: [
                {
                    title:"Think and grow Rich",
                    author: "Napoleon Hill",
                    img: require("@/assets/images/book_covers/think_and_grow_rich.jpg"),
                    summary: "Think and Grow Rich is the number-one inspirational and motivational classic for individuals who are interested in furthering their lives and reaching their goals by learning from important figures in history. The text read in this audiobook is the original 1937 edition written by Napoleon Hill and inspired by Andrew Carnegie, and while it has often been reproduced, no updated version has ever been able to compete with the original. It has been used as a roadmap to achievement by countless individuals.",
                    ref: "https://www.amazon.com.br/gp/product/0785833528/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=0785833528&linkCode=as2&tag=mylifeinpersp-20&linkId=022c0bb68693becdb0e90aa76a852007",
                },
                {
                    title:"The Alchemist",
                    author: "Paulo Coelho",
                    img: require("@/assets/images/book_covers/the_alchemist.jpg"),
                    summary: "Paulo Coelho's masterpiece tells the mystical story of Santiago, an Andalusian shepherd boy who yearns to travel in search of a worldly treasure. His quest will lead him to riches far different—and far more satisfying—than he ever imagined. Santiago's journey teaches us about the essential wisdom of listening to our hearts, of recognizing opportunity and learning to read the omens strewn along life's path, and, most importantly, to follow our dreams.",
                    ref: "https://amzn.to/31wZ0cr",
                },
                {
                    title:"You Can Heal Your Life",
                    author: "Louise Hay",
                    img: require("@/assets/images/book_covers/you_can_heal_your_life.jpg"),
                    summary: "In this inspirational work, world renowned teacher Louise L. Hay offers profound insight into the relationship between the mind and the body. Exploring the way that limiting thoughts and ideas control and constrict us, she offers us a powerful key to understanding the roots of our physical diseases and discomforts.This practical self-help guide will change the way you think forever!",
                    ref: "https://amzn.to/3a6cxM1",
                },
                {
                    title:"Rich Dad, Poor Dad",
                    author: "Robert T. Kiyosaki",
                    img: require("@/assets/images/book_covers/rich_dad_poor_dad.jpg"),
                    summary: "Rich Dad Poor Dad is Robert's story of growing up with two dads — his real father and the father of his best friend, his rich dad — and the ways in which both men shaped his thoughts about money and investing. The book explodes the myth that you need to earn a high income to be rich and explains the difference between working for money and having your money work for you.",
                    ref: "https://amzn.to/3iqJiGR",
                },
                {
                    title:"The 7 Habits of Highly Effective People",
                    author: "Stephen R. Covey",
                    img: require("@/assets/images/book_covers/the_7_habits_of_highly_effective_people.jpg"),
                    summary: "The 7 Habits of Highly Effective People has captivated readers for 25 years. It has transformed the lives of Presidents and CEOs, educators, parents, and students—in short, millions of people of all ages and occupations have benefited from Dr. Covey's 7 Habits book. And, it can transform you.",
                    ref: "https://amzn.to/3ab8he7",
                },
                // {
                //     title:"",
                //     author: ""
                // },
                // {
                //     title:"Don’t Sweat the Small Stuff… And It’s All Small Stuff",
                //     author: "Richard Carlson"
                // },
                // {
                //     title:"Who Moved My Cheese?",
                //     author: "Spencer Johnson"
                // },
                // {
                //     title:"The Celestine Prophecy",
                //     author: "James Redfield"
                // },
                // {
                //     title:"The Secret",
                //     author: "Rhonda Byrne"
                // },
                // {
                //     title:"The Power of Positive Thinking",
                //     author: "Norman Vincent Peale"
                // },
            ]
        }
    },
    computed: {
        amountOfBooks: function () {
            return ((DateTime.local().diff(DateTime.local().startOf('year'), 'days').days*15000)/90000).toFixed(1);
        },
        weeksLeftToLive: function () {
            return DateTime.fromJSDate(this.birthdate).plus({years:this.lifeExpectancyInYears}).diff(DateTime.local(), 'weeks')['weeks'].toFixed(0);
            // return DateTime.local().diff(DateTime.fromJSDate(this.birthdate).plus({years:this.lifeExpectancyInYears}), 'weeks')['weeks'].toFixed(0);
        },
        monthsLeftToLive: function () {
            return DateTime.fromJSDate(this.birthdate).plus({years:this.lifeExpectancyInYears}).diff(DateTime.local(), 'months')['months'].toFixed(0);
        },
        yearsLeftToLive: function () {
            return DateTime.fromJSDate(this.birthdate).plus({years:this.lifeExpectancyInYears}).diff(DateTime.local(), 'years')['years'].toFixed(0);
        },
    }, 
    methods: {
        
    }
}
</script>

<style>
.book-list{
    padding: 2.2rem 0;
    list-style: none;
}
</style>